import { langFallback$Fetch } from '../../lang/utils/langfetch'
import { Faq, FaqStandalone, faqSchema, faqStandaloneSchema } from './schemas'
import { FaqResponse, FaqStandaloneResponse } from './types'

export class FaqRepositoryFetch {
  async getAll(langCode: string): Promise<Faq[]> {
    const faqs = await langFallback$Fetch<FaqResponse[]>(
      langCode,
      '/about/faq/?json',
    )
    return faqs.map((faq) => faqSchema.parse(faq))
  }

  async getStandaloneBySlug(
    langCode: string,
    slug: string,
  ): Promise<FaqStandalone> {
    const faq = await langFallback$Fetch<FaqStandaloneResponse>(
      langCode,
      `/about/faqs/${slug}/?json`,
    )
    return faqStandaloneSchema.parse(faq)
  }
}
